export default {
  left_column: {
    title: 'Controlla saldo',
    description:
      'Inserisci il codice della gift card per verificare il saldo residuo. Il codice si trova nel PDF della tua gift card.',
  },
  title: 'Controlla il saldo della carta regalo',
  subtitle: 'Inserisci un codice carta regalo per verificarne il saldo attuale',
  error: {
    title: 'Carta regalo non trovata!',
    description: 'Inserisci un codice carta regalo valido.',
  },
  gift_card: {
    title: 'Carta regalo trovata!',
    balance: 'Saldo',
    value: 'Valore',
    expires_at: 'Scade il',
  },
  form: {
    code: {
      label: 'Codice carta regalo',
    },
  },
  buttons: {
    check_balance: 'Controlla saldo',
  },
};
